"use strict";

var CramFile = require('./file');

module.exports = CramFile;